
<div class="cp-modal" :class="{overlay: modal.show && modal2.show}">
  <slot />
</div>
